import { useState } from "react";
import { PageLayout } from "../components/Layout";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { ExternalLink, Search } from "lucide-react";

const WORKFORCE_URL = "https://workforcedirectory.pplx.app/";

const WorkforceDirectoryPage = () => {
  const [zip, setZip] = useState(new URLSearchParams(window.location.search).get("zip") || "");
  const [iframeKey, setIframeKey] = useState(0);

  return (
    <PageLayout
      title="US Workforce Directory"
      subtitle="Match participants to their local Workforce Development Board by zipcode. (Admins only)"
    >
      <div className="space-y-4" data-testid="workforce-directory">
        <Card className="card-surface">
          <CardContent className="pt-4 pb-4">
            <div className="flex items-center gap-3 flex-wrap">
              <div className="flex-1 min-w-[200px] relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <Input
                  value={zip}
                  onChange={(e) => setZip(e.target.value)}
                  placeholder="Enter zipcode to look up"
                  className="input-base pl-10"
                  data-testid="zip-input"
                />
              </div>
              <Button onClick={() => setIframeKey((k) => k + 1)} className="btn-primary">
                Reload Directory
              </Button>
              <a href={WORKFORCE_URL} target="_blank" rel="noopener noreferrer">
                <Button variant="outline" className="flex items-center gap-2">
                  <ExternalLink className="w-4 h-4" /> Open Directly
                </Button>
              </a>
            </div>
            {zip && (
              <p className="text-sm text-slate-500 mt-3">
                Looking up zipcode <span className="font-mono font-semibold text-slate-900">{zip}</span> — paste it into the directory below.
              </p>
            )}
          </CardContent>
        </Card>

        <Card className="card-surface overflow-hidden p-0">
          <iframe
            key={iframeKey}
            src={WORKFORCE_URL}
            title="US Workforce Directory"
            className="w-full"
            style={{ height: "calc(100vh - 280px)", minHeight: "600px", border: 0 }}
            sandbox="allow-scripts allow-forms allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            data-testid="workforce-iframe"
          />
        </Card>

        <p className="text-xs text-slate-400 text-center">
          Powered by workforcedirectory.pplx.app · Aspiritech embeds this third-party tool for admin convenience.
        </p>
      </div>
    </PageLayout>
  );
};

export default WorkforceDirectoryPage;
